import { useQueryClient } from 'react-query';
import { PaymentPlanHistoryItem } from '@frontend/api-payment-plans';
import { PaymentQueries } from '@frontend/api-payments';
import { updatePlanHistoryQueryCache } from '../utils/payment-plan-cache-helpers';
import { useTogglePaymentRecorded } from './use-toggle-payment-recorded';

interface UseTogglePaymentPlanRecordedParams {
  paymentPlanId: string;
  locationId: string | undefined;
}

export const useTogglePaymentPlanRecorded = ({ paymentPlanId, locationId }: UseTogglePaymentPlanRecordedParams) => {
  const queryClient = useQueryClient();
  const { invalidateUnrecordedCount } = PaymentQueries.usePaymentsInvalidation();

  const { toggleRecorded, ...toggleRecordedInfo } = useTogglePaymentRecorded<PaymentPlanHistoryItem>({
    onMutate: ({ data: planHistoryItem }) => {
      const paymentPlanInvoiceId = planHistoryItem?.payment?.id;
      if (!paymentPlanInvoiceId) return;

      const newPlanHistoryItem: PaymentPlanHistoryItem = {
        ...planHistoryItem,
        payment: planHistoryItem?.payment && {
          ...planHistoryItem?.payment,
          recordedAt: planHistoryItem?.payment?.recordedAt ? undefined : new Date().toISOString(),
        },
      };

      updatePlanHistoryQueryCache(queryClient, paymentPlanId, newPlanHistoryItem);

      return () => updatePlanHistoryQueryCache(queryClient, paymentPlanId, planHistoryItem);
    },
    onSuccess: () => invalidateUnrecordedCount(!!locationId ? [locationId] : []),
  });

  return {
    toggleRecorded,
    ...toggleRecordedInfo,
  };
};
